module.exports = __webpack_public_path__ + "img/upload.14046e6a.svg";